import { BrowserRouter, Routes, Route } from 'react-router-dom'
import React, { Suspense, lazy } from 'react';

import Navbar from './components/Navbar'; // Import Navbar
import { ScrollArrow } from "./components/scroll";
import ScrollToTop from './components/scrolltop';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Product = lazy(() => import('./pages/Product'));
const ProductDetails = lazy(() => import('./pages/ProductDetails'));
const ContactUs = lazy(() => import('./pages/ContactUs'));

function App() {
  return (
    <BrowserRouter>
     <ScrollToTop />
     <Navbar /> 
     <Suspense fallback={<div>Loading...</div>}></Suspense>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Product />} /> {/* Product listing page */}
        <Route path="/product/:id" element={<ProductDetails />} /> {/* Dynamic route */}
        <Route path="/contactus" element={<ContactUs />} /> {/* ContactUs route */}
      </Routes>
      <ScrollArrow />
    </BrowserRouter>
  )
}

export default App
